import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { RequestService } from '../../../services/request.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
//import { PagesLayoutComponent } from '../../../layouts/pages-layout/pages-layout.component';

@Component({
  selector: 'app-request-detail',
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss']
})
export class RequestDetailComponent implements OnInit {

    constructor( private route: ActivatedRoute,
        private router: Router, private requestService: RequestService, private authentication: AuthenticationService, private common: CommonService) { }
    id: string = "0";
    detail: any = {
        id: 0,
        requestFor: "",
        subject: "",
        location: "",
        description: "",
        createdDate: "",
        requestedName: "",
        requestedContactLogo: "",
        requestedOrganization: "",
        status: ""
    };

    replies: any[] = [];

    description: string = "";
    isError: boolean = false;
    errorMessage: string = "";

    btnVerifyText = "SEND";
    btnVerifyDisabled = false;

    pagecode: string = "request-detail";
    module: string = "request";
    accessdenied: boolean = false;

    ngOnInit(): void {

        let map: any = this.route.paramMap;
        this.id = map.destination._value.id;

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);



                        this.getRequestById();

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );

        });



    }


    getRequestById() {
        this.requestService.getRequestById(this.authentication._authentication.id, this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.detail = {
                        id: res.data.id,
                        requestFor: res.data.requestFor,
                        subject: res.data.subject,
                        location: res.data.location,
                        description: res.data.description,
                        createdDate: res.data.createdDate,
                        requestedName: res.data.fromPortalUser.firstName + ' ' + res.data.fromPortalUser.lastName,
                        requestedContactLogo: res.data.fromPortalUser.contactLogo,
                        requestedOrganization: res.data.fromPortalUser.portalAccount.name,
                        status: res.data.status
                    };
                    this.getRequestReplies();
                }
                else {
                    console.error("Web / Request / detail: " + this.id + " / getRequestById()", res.error_message);
                    this.errorMessage = res.error_message;
                    this.isError = true;
                }
            },
            (err: any) => {
                console.error("Web/Request/detail:" + this.id + "/getRequestById()", err);
                this.errorMessage = err;
                this.isError = true;
            }
        );
    }


    getRequestReplies() {
        this.requestService.getRequestReplies(this.authentication._authentication.id, this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.replies = res.data;
                }
                else {
                    console.error("Web / Request / detail: " + this.id + " / getRequestReplies()", res.error_message);
                    this.errorMessage = res.error_message;
                }
            },
            (err: any) => {
                console.error("Web/Request/detail:" + this.id + "/getRequestReplies()", err);
                this.errorMessage = err;
            }
        );
    }

    addRequestReply() {
        if (this.description != "") {

            this.btnVerifyText = "Sending...";
            this.btnVerifyDisabled = true;

            this.requestService.submitRequestReply(this.id, this.description, this.authentication._authentication.id).subscribe(
                (res: any) => {
                    this.btnVerifyText = "SEND";
                    //console.log("addRequestReply success");
                    //console.log(res)

                    this.btnVerifyDisabled = false;

                    if (res.success) {

                        this.description = "";
                        this.replies.push(res.data);
                    }
                    else {
                        //   this.toastr.error(res, 'Oops!');
                        this.common.ShowMessage('error', res.error_message, '')
                    }
                },
                (err: any) => {
                    this.btnVerifyText = "SEND";
                    this.btnVerifyDisabled = false;
                    console.error("Web/Request/Submit/addRequestReply()", err);
                }
            );
        }
        else
            this.common.ShowMessage('error', "reply is mandatory", '');
    }


}